import React from "react";
import DropdownWrapper from "react-dropdown-wrapper";
import { FormattedMessage } from "react-intl";
import { sportsIconMap, sportsSlugIdMap } from "../Common/constants";
import cn from "classnames";

export function GameListSwitcherMobile({ options, currentKey, onFetchGames}){
  return (
    <div className="gamelist-switcher-mobile">
      <div className="mobile-select">
          {options && options.length > 0 && (
            <ul>
              {options.map((e) => (
                <li
                  onClick={() => {
                    onFetchGames(e.status, e.scope);
                  }}
                  key={e.scope + e.status}
                  className={`cat-item${(e.status === currentKey.status) && (e.scope === currentKey.scope) ? ' cat-active' : ''}`}
                >
                  {e.formattedMessageId ? <FormattedMessage id={e.formattedMessageId} /> : e.text ? e.text : "Please select"}
                </li>
              ))}
            </ul>
          )}
        </div>
    </div>
  )
}

export function SportSelectMobile({ onClick, activeFilter, filters }) {
    return (
      <div className="mobile-select-container">
        <h3 className="select-label">Choose Sports:</h3>
        <div className="mobile-select">
          <DropdownWrapper
            closeOnEsc
            wrapperProps={{
              className: "dropdown-wrapper",
            }}
          >
            {({ changeStatus, isShow }) => (
              <>
                <button
                  className="dropdown-toggle"
                  onClick={() => changeStatus(!isShow)}
                >
                  {activeFilter && activeFilter.slug && activeFilter.slug !== "all-sports" ? (
                    <span className="drowndown-icon-container">
                      <i
                        className={cn(
                          "z-icon",
                          "dropdown-sports-icon",
                          sportsIconMap[sportsSlugIdMap[activeFilter.slug]]
                        )}
                      />
                    </span>
                  ) : null}

                  {activeFilter && activeFilter.name
                    ? activeFilter.name
                    : "Please select"}
                </button>
                {isShow && filters && filters.length > 0 && (
                  <div className="dropdown">
                    {filters.map((filter) => (
                      <div
                        onClick={() => {
                          onClick((filter));
                          changeStatus(!isShow);
                        }}
                        key={filter.slug}
                        className="dropdown-item"
                      >
                        {filter.name}
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </DropdownWrapper>
        </div>
      </div>
    );
  }